import Vue from 'vue'
import Vuex from 'vuex'
import LogRocket from 'logrocket';
import createPlugin from 'logrocket-vuex';

Vue.use(Vuex)

const logrocketPlugin = createPlugin(LogRocket);

export default new Vuex.Store({
  state: {
    classData: null
  },
  getters: {
    getClassData: state => {
      return state.classData
    }
  },
  mutations: {
    setClassData(state, data) {
      state.classData = data
    }
  },
  actions: {
    setClassData({ commit }, data) {
      commit('setClassData', data)
    }
  },
  modules: {
  },
  plugins : [logrocketPlugin]
})

